define(function() {

	"use strict";

	var data = {
		'h1': {
			'default': {
				fontFamily: 'Ekibastuz',
				fontWeight: 700,
				letterSpacing: -0.03,
				lineHeight: 1.2,
				color: 'dynamic'
			},
			'mobile': {
				size: 30,
			},
			'tablet': {
				size: 58,
			},
			'desktop': {
				size: 58,
			}
		},
		'h2': {
			'default': {
				fontFamily: 'Ekibastuz',
				fontWeight: 700,
				letterSpacing: -0.03,
				lineHeight: 1.2,
				color: '#2d2828'
			},
			'mobile': {
				size: 30,
			},
			'tablet': {
				size: 55,
			},
			'desktop': {
				size: 55,
			}
		},
		'h4': {
			'default': {
				fontFamily: 'Ekibastuz',
				fontWeight: 700,
				letterSpacing: -0.03,
				lineHeight: 1.3,
				size: 22,
				color: '#2d2828'
			}
		},
		'h4-cl': {
			'default': {
				fontFamily: 'Ekibastuz',
				fontWeight: 700,
				letterSpacing: -0.03,
				lineHeight: 1.3,
				size: 22,
				color: 'dynamic'
			}
		},
		'h4-big': {
			'default': {
				fontFamily: 'Ekibastuz',
				fontWeight: 700,
				letterSpacing: -0.03,
				lineHeight: 1.3,
				size: 22,
				color: '#2d2828'
			},
			'tablet': {
				fontWeight: 700,
				lineHeight: 1.2,
				size: 55
			},
			'desktop': {
				fontWeight: 700,
				lineHeight: 1.2,
				size: 55
			}
		},
		'nm': {
			'default': {
				fontFamily: 'Ekibastuz',
				fontWeight: 900,
				letterSpacing: -0.03,
				lineHeight: 1,
				size: 200,
				color: '#ffffff'
			},
			'mobile': {
				size: 130
			},
			'tablet': {
				size: 180
			},
			'desktop': {
				size: 160
			},
			'wide': {
				size: 180
			}
		}
	}

	return data;
});